import { forwardRef } from "react";
import { Debounce } from "@/components/Debounce";
import { Input } from "./ui/input";

interface DebounceInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  debounce?: number;
  onOriginalInput?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  as?: React.ElementType;
}

const DebounceInput = forwardRef<HTMLInputElement, DebounceInputProps>(
  ({ onChange, debounce, onOriginalInput, as, ...props }, ref) => {
    const Component = as || Input;
    return (
      <Debounce
        onDebouncedChange={onChange}
        debounce={debounce}
        onOriginalInput={onOriginalInput}
      >
        <Component {...props} ref={ref} />
      </Debounce>
    );
  },
);

DebounceInput.displayName = "DebounceInput";

export { DebounceInput };
